import { apiClient } from '@/services/api';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ENDPOINTS } from '@/settings/api-settings';
import { ISieve } from '@/interfaces/sieves';
import { IType } from '@/interfaces/rules-engine';

function getSieves(): Observable<ISieve[]> {
  return from(apiClient.get(ENDPOINTS.SIEVES)).pipe(map((r: any) => r.data));
}
function saveSieve(payload: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.SIEVES, payload)).pipe(
    map((r: any) => r.data),
  );
}
function updateSieve(payload: any): Observable<any> {
  return from(apiClient.post(ENDPOINTS.SIEVES, payload)).pipe(
    map((r: any) => r.data),
  );
}
function deleteSieve(id: number): Observable<any> {
  return from(
    apiClient.delete(`${ENDPOINTS.SIEVE}`, {
      id,
    }),
  ).pipe(map((r: any) => r.data));
}
function getSievesTypes(): Observable<IType[]> {
  return from(apiClient.get(ENDPOINTS.SIEVES_TYPES)).pipe(
    map((r: any) => r.data),
  );
}

export { getSieves, saveSieve, updateSieve, deleteSieve, getSievesTypes };
